import type {RulesetTarget, TargetObjectType, TargetType} from '@github-ui/repos-rules-types/rules-types'

export const SHORT_SHA_LENGTH = 7

export const PLURAL_RULESET_TARGETS: {[key in RulesetTarget]: string} = {
  branch: 'branches',
  tag: 'tags',
  push: 'pushes',
  repository: 'repositories',
  actions: 'actions',
}

export const PLURAL_TARGET_OBJECT_TYPES: {[key in TargetObjectType]: string} = {
  ref: 'refs',
  repository: 'repositories',
  organization: 'organizations',
  workflow: 'workflows',
}

export const EXAMPLE_CONDITION_TARGET_PATTERNS: {
  [targetType: string]:
    | {
        [rulesetTarget: string]: string[]
      }
    | undefined
} = {
  ref_name: {
    branch: ['main', 'releases/**/*', 'users/**/*'],
    tag: ['*-beta', 'releases/**/*', 'v*'],
  },
  repository_name: {
    branch: ['prod-*', 'test-*'],
    tag: ['prod-*', 'test-*'],
  },
  workflow_path: {
    actions: ['.github/workflows/deploy.yml', '.github/workflows/release-*.yml', '.github/workflows/**'],
  },
}

export const TEST_IDS = {
  metadataRulePanelSpan: 'metadata-span',
}

// Annotated as an exhaustive Record so that adding a TargetType without mapping it
// to its object is a compile error. Without the annotation a missing entry is
// silent: conditionsByObject's lookup misses, the memo synthesizes an empty
// default, and an admin's saved patterns are shown blank and overwritten on save.
export const TARGET_OBJECT_BY_TYPE: Record<TargetType, TargetObjectType> = {
  repository_name: 'repository',
  repository_id: 'repository',
  repository_property: 'repository',
  ref_name: 'ref',
  organization_name: 'organization',
  organization_id: 'organization',
  organization_property: 'organization',
  workflow_path: 'workflow',
}
export const TARGET_OBJECT_TYPES: TargetObjectType[] = ['organization', 'repository', 'ref', 'workflow']

export const UNKNOWN_REF_NAME = 'refs/__gh__/UNKNOWN'
export const PENDING_OID = 'PENDING'

export const INHERITED_SOURCE_TYPE_ORDER_MAP = {
  Enterprise: 0,
  Organization: 1,
  Upstream: 2,
  Repository: 3,
}

export const IMPORT_LOCAL_STORAGE_KEY = 'repos-rules/imported-ruleset'

export const STATIC_BYPASS_ACTOR_TYPES = ['DeployKey', 'OrganizationAdmin']

export const DEBOUNCE_DELAY_MS = 300
